/** @jsx jsx */
import { jsx } from '@emotion/core'
import React from 'react'
import { observer } from 'mobx-react'
import { useOnMount } from '@utils/reactExt'
import { NaverAuthResultPageWrap } from '@views/NaverAuthResult/index.style'
import * as Utils from '@utils/utils'

const NaverAuthResultPage: React.FC = props => {

  useOnMount(async () => {
    console.log('[naverLogin] - authResultPage')
    console.log('[naverLogin] - getNaverAccessToken')
    const accessToken = Utils.getNaverAccessToken()
    console.log('[naverLogin] - loginByNaver')

    if (!window.opener) {
      window.location.replace('/')
      return
    }

    window.opener.window.v2.authStore.loginByNaver(accessToken)
    console.log('[naverLogin] - close')
    window.self.close()
  })

  return (
    <NaverAuthResultPageWrap/>
  )
}
export default observer(NaverAuthResultPage)
